import * as React from 'react';
import { useTasksList } from '../queries';

import {
  ContentProvider,
  ContentList,
  FiltersForm,
  Sort,
  SearchInput,
} from 'templates/content';
import { Container, Wrapper, TopBar } from 'common/components';
import TaskRow from '../components/TaskRow';

const fields = {
  search: 'search',
  sort: 'sort',
};

const TasksList = () => {
  const { data, isError } = useTasksList();
  const context = {
    data: data?.values.map(({ executor, ...tag }) => ({ ...tag, title: executor })),
  };

  return (
    <Container>
      <ContentProvider {...context}>
        <TopBar title="Background tasks">
          <FiltersForm sort={['title', fields.sort]} search={['title', fields.search]}>
            <Wrapper margin={[0, 0.5]}>
              <SearchInput name={fields.search} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <Sort name={fields.sort} />
            </Wrapper>
          </FiltersForm>
        </TopBar>
        <ContentList isError={isError}>{TaskRow}</ContentList>
      </ContentProvider>
    </Container>
  );
};

export default TasksList;
